import { EVENT } from "../../Config/Constants/EventConstant";
import { getEvents } from "../Services/EventService";

export const getEventsAction = (textSearch, sort, order, limit, offset) => ({
    type: EVENT.GET_EVENT,
    payload: getEvents(textSearch, sort, order, limit, offset),
});
